import { logFetchPrefix } from "@/modules/fetch/constants"

import { logger } from "./logger"

export async function logServerFetch(id: string, promise: Promise<Response>): Promise<Response> {
  if (process.env.LOG_SERVER_FETCH !== "true" || typeof window !== "undefined") {
    return promise
  }

  const start = new Date()

  return promise
    .then((...args) => {
      const stop = new Date()
      const duration = stop.valueOf() - start.valueOf()

      const [response] = args
      const loggingMethod = (response.status < 400 ? logger.info : logger.error).bind(logger)

      loggingMethod(
        {
          http_status: response.status,
          request_time: duration / 1000,
          request_url: response.url,
        },
        id
      )

      return Promise.resolve(...args)
    })
    .catch(err => {
      const stop = new Date()
      const duration = stop.valueOf() - start.valueOf()

      logger.error(
        {
          error: err.message,
          request_time: duration / 1000,
          request_url: id.replace(logFetchPrefix, ""),
        },
        id
      )

      throw err
    })
}
